module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.4.1/css/bulma.min.css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "https://fonts.googleapis.com/icon?family=Material+Icons",
      "rel": "stylesheet"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.repoUrl
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section",
    staticStyle: {
      "padding-top": ".5rem"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "box formated"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "field is-pulled-left"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Color")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('chrome-picker', {
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field has-text-left"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.position),
      expression: "position"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.position = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.positions), function(pos) {
    return _c('option', [_vm._v(_vm._s(pos))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "field has-text-left"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position Type")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expandend"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.positionType),
      expression: "positionType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.positionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.positionTypes), function(type) {
    return _c('option', [_vm._v(_vm._s(type))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "field has-text-left"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Size")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expandend"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconSizes),
      expression: "iconSizes"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.iconSizes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sizes), function(size) {
    return _c('option', [_vm._v(_vm._s(size))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "field has-text-left"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Tooltip event")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expandend"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tooltipEvent),
      expression: "tooltipEvent"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tooltipEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tooltipEvents), function(type) {
    return _c('option', [_vm._v(_vm._s(type))])
  }))])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-right": "1rem"
    }
  }, [_vm._v("\n                                            Main Icon & Tooltip\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainIcon),
      expression: "mainIcon"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mainIcon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mainIcon = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainTooltip),
      expression: "mainTooltip"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mainTooltip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mainTooltip = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-right": "1rem"
    }
  }, [_vm._v("\n                                            First Icon & Tooltip\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstIcon),
      expression: "firstIcon"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstIcon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstIcon = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstTooltip),
      expression: "firstTooltip"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstTooltip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstTooltip = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-right": "1rem"
    }
  }, [_vm._v("\n                                            Second Icon & Tooltip\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondIcon),
      expression: "secondIcon"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondIcon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondIcon = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondTooltip),
      expression: "secondTooltip"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondTooltip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondTooltip = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-right": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableRotation),
      expression: "enableRotation"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enableRotation) ? _vm._i(_vm.enableRotation, null) > -1 : (_vm.enableRotation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableRotation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.enableRotation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableRotation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableRotation = $$c
        }
      }
    }
  }), _vm._v("\n                                            Enable Rotation\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": _vm.repoUrl
    }
  }, [_vm._v("Installation & Code usage")])])])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('strong', [_vm._v("Floating Action Button Vue Component")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": _vm.teamUrl
    }
  }, [_vm._v("Pygmy Team")]), _vm._v(".\n                    ")]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('fab', {
    attrs: {
      "position": _vm.position,
      "icon-size": _vm.iconSizes,
      "position-type": _vm.positionType,
      "bg-color": _vm.colors.hex,
      "main-icon": _vm.mainIcon,
      "main-tooltip": _vm.mainTooltip,
      "actions": [{
        name: 'alertMe',
        icon: _vm.firstIcon,
        tooltip: _vm.firstTooltip,
        color: '#d11014'
      }, {
        name: 'alertMe',
        icon: _vm.secondIcon,
        tooltip: _vm.secondTooltip
      }],
      "fixed-tooltip": _vm.fixedTooltip,
      "enable-rotation": _vm.enableRotation
    },
    on: {
      "alertMe": _vm.alert
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding": "1rem 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "is-pulled-left"
  }, [_c('img', {
    attrs: {
      "width": "350px",
      "src": require("./assets/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "is-pulled-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h1', {
    staticClass: "title text-medium-grey",
    staticStyle: {
      "margin-bottom": ".5rem"
    }
  }, [_vm._v("\n                                    Floating Action Button\n                                ")]), _vm._v(" "), _c('hr', {
    staticClass: "is-marginless"
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle text-light-grey",
    staticStyle: {
      "margin-top": ".5rem"
    }
  }, [_vm._v("\n                                    A Vue Component\n                                    "), _c('span', {
    staticClass: "is-pulled-right"
  }, [_c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/PygmySlowLoris/vue-fab",
      "data-icon": "octicon-star",
      "data-size": "large",
      "aria-label": "Star PygmySlowLoris/vue-fab on GitHub"
    }
  }, [_vm._v("Star")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('i', {
    staticClass: "material-icons top-left"
  }, [_vm._v("code")]), _vm._v(" "), _c('span', {
    staticClass: "is-pulled-right"
  }, [_c('b', [_vm._v("Example")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Used dependencies for this demo: "), _c('a', {
    attrs: {
      "href": "http://bulma.io"
    }
  }, [_vm._v("bulma")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://github.com/xiaokaike/vue-color"
    }
  }, [_vm._v("vue-color")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d877a75c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = 18
// module chunks = 0